import { LogOut, Menu, User } from 'lucide-react'
import { useAuth } from '@/lib/auth-context'

interface HeaderProps {
  onToggleSidebar: () => void
}

export function Header({ onToggleSidebar }: HeaderProps): React.JSX.Element {
  const { user, logout } = useAuth()

  return (
    <header className="flex h-16 items-center justify-between border-b border-surface-3 bg-surface-0 px-4 lg:px-6">
      <button
        type="button"
        onClick={onToggleSidebar}
        className="rounded-lg p-2 text-text-secondary hover:bg-surface-1 lg:hidden"
      >
        <Menu className="h-5 w-5" />
      </button>

      <div className="hidden lg:block" />

      <div className="flex items-center gap-3">
        {user && (
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 rounded-lg bg-surface-1 px-3 py-1.5">
              <User className="h-4 w-4 text-text-tertiary" />
              <span className="text-sm text-text-primary">{user.email}</span>
            </div>
            <button
              type="button"
              onClick={logout}
              className="rounded-lg p-2 text-text-secondary hover:bg-surface-1 hover:text-text-primary"
              title="Log out"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        )}
      </div>
    </header>
  )
}
